// 退款状态码
export const refundStatusCode = {
  ALL: 0,
  INIT: 1,
  WAITING_SELLER: 2,
  COMFIRM_SELLER: 3,
  REFUSE_SELLER: 4,
  SUCCESS: 5,
  FAILD: 6
}
// 退款商品类型
export const refuseOrderType = {
  NORMAL: 1, // 普通订单
  XSG: 2 // 限时购
}
// 退款动作
export const refuseActionType = {
  ALL: 0,
  MONEY: 1, // 退款
  GOODS: 2, // 退货
  GOODS_MONEY: 3 // 全部退货退款
}
// 退款方式
export const refundWay = {
  ALL: 0,
  OFFLINE_DEAL: 1, // 线下交易
  RETURN_TO_BALANCE: 2, // 退回到余额
  RETURN_ALL_SAME: 3 // 全部退款原路退回
}
